import { storage } from '@/lib/storage';
import { Reactotron, reduxPlugin, sagaPlugin } from '@/lib/ReactotronConfig';

function reactotronInitializer() {
  const reactotronEnabled = storage().reactotronEnabled().get();

  if (reactotronEnabled) {
    Reactotron.configure({ name: 'Dokka app' }).use(reduxPlugin()).use(sagaPlugin()).connect();
  }
}

export default reactotronInitializer;
